module.exports = __webpack_public_path__ + "static/img/16.71fa50e.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/7/1/1/zh/16.png
// module id = cXpR
// module chunks = 0